import React from "react";
import { Editor } from "react-draft-wysiwyg";
import { convertToRaw } from "draft-js";
import draftToHtml from "draftjs-to-html";
import { useDispatch, useSelector } from "react-redux";
import {
  setSingleTemplateContent,
  setSingleTemplateHTMLContent,
} from "../../../../../redux/actions/single-template";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";
import "./style.scss";

const Index = () => {
  const dispatch = useDispatch();
  const content = useSelector((state) => state.singleTemplate.details.content);

  const handleEditorChange = (state) => {
    convertContentToHTML(state);
  };

  const convertContentToHTML = (state) => {
    let currentContentAsHTML = draftToHtml(
      convertToRaw(content.getCurrentContent())
    );
    dispatch(setSingleTemplateContent(state));
    dispatch(setSingleTemplateHTMLContent(currentContentAsHTML));
  };

  return (
    <div className="template-container email">
      <Editor
        wrapperClassName="template-composer-wrapper"
        editorClassName="editor-composer-wrapper"
        toolbarClassName="toolbar-composer-wrapper"
        placeholder="Skriv her"
        editorState={content}
        onEditorStateChange={(state) => handleEditorChange(state)}
      />
    </div>
  );
};

export default Index;
